/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DocumentSite
 */
export interface DocumentSite {
  /**
   *
   * @type {string}
   * @memberof DocumentSite
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof DocumentSite
   */
  displayName: string
}

export function DocumentSiteFromJSON(json: any): DocumentSite {
  return DocumentSiteFromJSONTyped(json, false)
}

export function DocumentSiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentSite {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    displayName: json['display_name']
  }
}

export function DocumentSiteToJSON(value?: DocumentSite | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    display_name: value.displayName
  }
}
